<template>
  <v-app>
    <v-app-bar app dark>
      <!-- 戻る -->
      <v-btn icon v-if="arrow" @click="onClickArrow">
        <v-icon>fas fa-arrow-left</v-icon>
      </v-btn>

      <v-spacer />
      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <v-spacer />

      <!-- カートアイコン -->
      <!-- <v-btn v-if="cart" icon @click="onClickCart">
        <v-img
          v-on:animationend="animationEnd"
          class="cartIcon animate__animated"
          :class="classCartIcon"
          max-height="30px"
          contain
          v-bind:src="resourcePath"
        ></v-img>
      </v-btn> -->

      <!-- debug -->
      <!-- <v-btn
        v-if="debug"
        rounded
        class="ma-2 white--text grey darken-1"
        @click="onClickDebug"
        >DEBUG</v-btn
      > -->
    </v-app-bar>

    <v-main>
      <v-container flued class="pa-0">
        <router-view />
      </v-container>
    </v-main>

    <v-footer app></v-footer>

    <v-overlay v-show="progress">
      <v-progress-circular indeterminate size="80" />
    </v-overlay>
  </v-app>
</template>

<script>
import liff from "@line/liff";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "App",
  components: {},
  data: () => ({
    // カートアイコン
    doAnimate: false,
    resourcePath: "",
  }),
  computed: {
    ...mapGetters([
      "allowPc",
      "shopId",
      "debug",
      "progress",
      "appBar",
      "arrow",
      "title",
      "cart",
      // "cartItemSize",
      // "cartDoAnimate",
    ]),
    // カートアイコン
    classCartIcon: function () {
      return {
        // animate.css (https://animate.style/)
        animate__bounceInUp: this.doAnimate,
      };
    },
  },
  watch: {
    // cartItemSize: function () {
    //   this.refreshCartIcon();
    // },
  },
  async created() {
    // shopId 保存
    const shopId = this.$route.params.shopId;
    this.$store.commit("shopId", shopId);

    //TODO デバッグ判定 (liffMock 使って isInClient 実装する)
    // LIFF 以外はエラーページ遷移 (デバッグ時は無条件に通す)
    if (!this.debug && !liff.isInClient() && !this.allowPc) {
      // エラーページ (読込失敗)
      this.hideProgress();
      this.$router.replace({ name: "AccessDenied" });
      return;
    }

    // LIFF 初期化 (ミニアプリは liffId 固定)
    const liffId = process.env.VUE_APP_LIFF_ID;
    await liff.init({ liffId });
  },
  mounted() {
    //--------------------------------------------------
    // カートアイコン制御
    // - 初期表示時 --> アニメーションしない
    // - カート内アイテム数変更時 --> アニメーションする
    //--------------------------------------------------
    // 「カートへ追加」押下時以外はアニメーションさせない
    // this.$store.state.cartDoAnimate = false;
    // アイコン設定 (初期表示)
    // this.changeCartIcon();
  },
  methods: {
    ...mapActions(["showProgress", "hideProgress"]),
    ...mapActions("settings", ["loadSettings"]),
    onClickDebug: function () {
      this.$router.replace({ name: "Debug" });
    },
    onClickArrow: function () {
      // const currentPath = this.$route.path;

      // 画面遷移
      window.history.state.canGoBack
        ? this.$router.go(-1) // 戻る(1つ前)
        : liff.closeWindow(); // LIFF 閉じる
    },
    // onClickCart: function () {
    //   console.log("click cart");
    //   this.$router.push({ name: "Cart" });
    // },
    // refreshCartIcon: function () {
    //   // アイコン切替
    //   // - アイコン非表示でも必ず裏で行っておく
    //   // - 「戻る」実行すると変更前アイコンが表示されてしまうため
    //   this.changeCartIcon();

    //   // アニメーション
    //   if (!this.cart) {
    //     // アイコン非表示中はアニメーションさせない(キューイングするとエラー発生)
    //     return;
    //   } else if (this.cartDoAnimate) {
    //     // アニメーションON
    //     this.doAnimate = true;
    //   }
    // },
    // animationEnd: function () {
    //   this.doAnimate = false;
    // },
    // changeCartIcon: function () {
    //   const cartItemSize = this.cartItemSize;
    //   if (!cartItemSize || cartItemSize == 0) {
    //     this.resourcePath = require("@/assets/cart-empty-outline-300.svg");
    //   } else {
    //     this.resourcePath = require("@/assets/cart-in-outline-300.svg");
    //   }
    // },
  },
};
</script>
